module.exports = __webpack_public_path__ + "static/media/logo_color_2.0448b164.png";